import { debounce, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { EntrepotService } from "$services";
import { queryClient } from "$utils/queryClient";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  onChange: (val: any, ids?: any) => void;
  value: any;
  className?: string;
  disabled?: boolean;
  clientId?: string;
  label?: string;
  placeholder?: string;
  orderModule?: boolean;
};

function WarehouseSearchInput({
  disabled,
  className,
  clientId,
  label = "Entrepôt",
  placeholder = "Par nom",
  orderModule = false,
  value,
  onChange,
  ...props
}: Props) {
  const [localValue, setValue] = useState(value);
  const setDebouncedChange = useMemo(() => debounce(onChange, 300), [onChange]);

  const getDockyards = async (newName) => {
    const filters = {
      ...{ name: newName },
    };
    try {
      const queryKey = [CacheInvalidationAction.GET_ENTREPOTS, filters];
      let getWarehouses: any = await queryClient.getQueryData(queryKey);
      if (!getWarehouses) {
        getWarehouses = await queryClient.fetchQuery(
          queryKey,
          () => EntrepotService.getEntrepots(filters),
          { cacheTime: 5 * 60 * 1000 }
        );
        queryClient.setQueryData(queryKey, getWarehouses);
      }
      return getWarehouses?.data || [];
    } catch (error) {
      return null;
    }
  };

  const handleChange = async (currentValue: string) => {
    setValue(currentValue);

    // If the value is empty, clear the filter
    if (!currentValue || currentValue.trim() === "") {
      setDebouncedChange(undefined, undefined);
      return;
    }

    const docyards = await getDockyards(currentValue);
    setDebouncedChange(
      currentValue,
      docyards.map((c) => c._id)
    );
  };

  return (
    <TextField
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      value={orderModule ? localValue || "" : value}
      variant="outlined"
      type="text"
      onChange={(e: any) =>
        orderModule ? handleChange(e.target.value) : onChange(e)
      }
      label={label}
      style={{ width: "100%" }}
      {...props}
    />
  );
}

export default WarehouseSearchInput;

export const getWarehouseIdFilterResult = (
  filtered: any,
  filterWarehouse: any,
  warehouses: any
) => {
  if (filtered && filterWarehouse && filterWarehouse !== "") {
    return filtered?.filter((u: any) => {
      const warehouse = warehouses.find((w) => u.warehouses.includes(w._id));
      return warehouse.name
        .toLowerCase()
        .includes(filterWarehouse?.toLowerCase());
    });
  }
  return filtered;
};
